interface IconSchoolProps {
  active?: boolean;
}
export const IconSchool = ({ active }: IconSchoolProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1245_19937)">
        <path
          d="M22 14V17C22 18.66 20.66 20 19 20H18C18 18.9 17.1 18 16 18C14.9 18 14 18.9 14 20H10C10 18.9 9.1 18 8 18C6.9 18 6 18.9 6 20H5C3.34 20 2 18.66 2 17V14H13C14.1 14 15 13.1 15 12V5H16.84C17.56 5 18.22 5.39001 18.58 6.01001L20.29 9H19C18.45 9 18 9.45 18 10V13C18 13.55 18.45 14 19 14H22Z"
          stroke={active ? "#FF9934" : "#999999"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z"
          stroke={active ? "#FF9934" : "#999999"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z"
          stroke={active ? "#FF9934" : "#999999"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 12V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L22 12Z"
          stroke={active ? "#FF9934" : "#999999"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.50016 10.6068C7.31526 10.6068 7.57616 10.9731 8.30976 10.9731C9.04351 10.9731 9.5 10.4847 9.5 9.62978C9.5 8.77488 8.53808 8.31693 8.114 7.73668C7.69008 7.15658 7.39678 6.5 6.5 6.5C5.60323 6.5 5.30976 7.15658 4.88584 7.73668C4.46192 8.31678 3.5 8.77473 3.5 9.62978C3.5 10.4847 3.95649 10.9731 4.69024 10.9731C5.424 10.9733 5.6849 10.6068 6.50016 10.6068Z"
          stroke={active ? "#FF9934" : "#999999"}
          strokeWidth="1.5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.6002 1.51716C9.26449 1.64346 9.63193 2.43038 9.4215 3.27536C9.21088 4.12016 8.50194 4.70271 7.83803 4.57659C7.17393 4.45029 6.8063 3.66337 7.01673 2.81839C7.22735 1.97377 7.93629 1.39104 8.6002 1.51716Z"
          fill={active ? "#FF9934" : "#999999"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.11349 1.51716C3.44958 1.64346 3.08176 2.43038 3.29238 3.27536C3.50281 4.12016 4.21193 4.70271 4.87584 4.57659C5.53994 4.45029 5.90758 3.66337 5.69696 2.81839C5.48634 1.97377 4.77759 1.39104 4.11349 1.51716Z"
          fill={active ? "#FF9934" : "#999999"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.83472 4.09442C1.20527 4.21388 0.856701 4.96008 1.05619 5.76077C1.25567 6.56166 1.92772 7.11395 2.55738 6.99429C3.18684 6.87483 3.53541 6.12843 3.33572 5.32774C3.13623 4.52705 2.46418 3.97476 1.83472 4.09442Z"
          fill={active ? "#FF9934" : "#999999"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1651 4.09442C11.7946 4.21388 12.1434 4.96008 11.9437 5.76077C11.7442 6.56166 11.0719 7.11395 10.4425 6.99429C9.81301 6.87483 9.46444 6.12843 9.66413 5.32774C9.86362 4.52705 10.5359 3.97476 11.1651 4.09442Z"
          fill={active ? "#FF9934" : "#999999"}
        />
      </g>
      <defs>
        <clipPath id="clip0_1245_19937">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
